// extracted by mini-css-extract-plugin
module.exports = {"main":"Loading_main__106HD","text":"Loading_text__zzb3b"};